/* eslint-disable react-hooks/exhaustive-deps */
import React, { useLayoutEffect, useState } from "react";
import LayoutFooter from "../inc/LayoutFooter";
import LayoutHeader from "../inc/LayoutHeader";
import { RollbackOutlined } from "@ant-design/icons";
import { useParams, useNavigate } from "react-router-dom";
import { Layout, Col, Row, Select } from "antd";
import { Button, Card, Form, Input, Spin } from "antd";
import { displayMessage, postAPI } from "../../utils/common";
import { ERROR_MSG_TYPE, SUCCESS_MESSAGE } from "../../constants/messages";
import { EDIT_SEO, SEO_BY_ID } from "../../constants/api";
import { PAGES_TYPE } from "../../constants/constent";

function SeoUpdate() {
  const { Content } = Layout;
  const { id } = useParams();
  let history = useNavigate();
  let navigate = useNavigate();

  const [form] = Form.useForm();
  const [loading, setIsLoading] = useState(false);

  useLayoutEffect(() => {
    getIdDetail();
  }, []);
  const getIdDetail = () => {
    setIsLoading(true);
    var data = new FormData();
    data.append("id", id);
    const successFn = function (data) {
      if (data.status === true) {
        form.setFieldsValue({
          title: data.data.title,
          description: data.data.description,
          page: data.data.page,
          keyword: data.data.keyword,
          author: data.data.author,
        });
        setIsLoading(false);
      } else {
        setIsLoading(false);
        displayMessage(ERROR_MSG_TYPE, data.message);
      }
    };
    const errorFn = function () {
      setIsLoading(false);
      displayMessage(ERROR_MSG_TYPE, "Unable to Get Data");
    };
    postAPI(SEO_BY_ID, data, successFn, errorFn);
  };

  const updateData = (values) => {
    setIsLoading(true);
    const data = new FormData();
    data.append("id", id);
    if (values.title) {
      data.append("title", values.title);
    }
    if (values.description) {
      data.append("description", values.description);
    }
    if (values.keyword) {
      data.append("keyword", values.keyword);
    }
    if (values.author) {
      data.append("author", values.author);
    }
    if (values.page) {
      data.append("page", values.page);
    }
    const successFn = function (data) {
      if (data.status === true) {
        setIsLoading(false);
        history("/pages-seo");
        displayMessage(SUCCESS_MESSAGE, data.message);
      } else {
        setIsLoading(false);
        displayMessage(ERROR_MSG_TYPE, data.message);
      }
    };
    const errorFn = function () {
      setIsLoading(false);
      displayMessage(ERROR_MSG_TYPE, "Unable to Update Data");
    };
    postAPI(EDIT_SEO, data, successFn, errorFn);
  };
  return (
    <>
      <Layout>
        <LayoutHeader />
        <Content>
          <Card
            title="Update Page SEO"
            bordered={false}
            extra={
              <Button
                style={{
                  marginTop: "5px",
                  marginBottom: "5px",
                }}
                onClick={() => navigate(-1)}
                type="primary"
                ghost
              >
                <RollbackOutlined />
              </Button>
            }
          >
            <Spin spinning={loading}>
              <Form form={form} layout="vertical" onFinish={updateData}>
                <Row gutter={[16, 16]}>
                  <Col span={6}>
                    <Form.Item
                      name="page"
                      label="Page"
                      rules={[{ required: true }]}
                    >
                      <Select options={PAGES_TYPE} />
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item
                      name="title"
                      label="Title"
                      rules={[{ required: true }]}
                    >
                      <Input type={"text"} placeholder="Title" />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      name="keyword"
                      label="Keyword"
                      rules={[{ required: true }]}
                    >
                      <Input type={"text"} placeholder="Keyword" />
                    </Form.Item>
                  </Col>
                  <Col span={4}>
                    <Form.Item
                      name="author"
                      label="Author"
                      rules={[{ required: true }]}
                    >
                      <Input type={"text"} placeholder="Author" />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name="description"
                      label="Description"
                      rules={[{ required: true }]}
                    >
                      <Input.TextArea rows={4} placeholder="Description" />
                    </Form.Item>
                  </Col>
                </Row>

                <Row spceber>
                  <Col span={24}>
                    <Form.Item
                      style={{ float: "right" }}
                      label=""
                      colon={false}
                    >
                      <Button loading={loading} block htmlType="submit">
                        Update
                      </Button>
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </Spin>
          </Card>
        </Content>
        <LayoutFooter />
      </Layout>
    </>
  );
}
export default SeoUpdate;
